module.exports = __webpack_public_path__ + "img/gps-left.92d8e043.png";